import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import { formatApiError } from "../lib/api";

const ROLES = ["player", "coach", "club_admin", "promoter", "federation"];

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Register() {
  const { register, user } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "", role: "player" });
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/dashboard", { replace: true }); }, [user, navigate]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to Pick2Play!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4 py-10">
      <div className="w-full max-w-md pp-card-elevated p-8" data-testid="register-card">
        <Link to="/" className="block mb-8"><Logo /></Link>
        <h1 className="font-heading text-3xl font-bold">{t("register")}</h1>

        <button onClick={googleLogin} data-testid="register-google" className="mt-6 w-full pp-btn-secondary px-4 py-3 rounded-xl flex items-center justify-center gap-2">
          <span className="font-bold text-[#00E676]">G</span> {t("continue_with_google")}
        </button>

        <div className="my-5 flex items-center gap-3 text-xs text-zinc-500"><div className="flex-1 border-t border-white/10" /> {t("or")} <div className="flex-1 border-t border-white/10" /></div>

        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <input data-testid="reg-firstname" required value={form.first_name} onChange={set("first_name")} placeholder={t("first_name")} className="pp-input" />
            <input data-testid="reg-lastname" required value={form.last_name} onChange={set("last_name")} placeholder={t("last_name")} className="pp-input" />
          </div>
          <input data-testid="reg-email" required type="email" value={form.email} onChange={set("email")} placeholder={t("email")} className="pp-input" />
          <input data-testid="reg-password" required type="password" minLength={6} value={form.password} onChange={set("password")} placeholder={t("password")} className="pp-input" />
          <select data-testid="reg-role" value={form.role} onChange={set("role")} className="pp-input">
            {ROLES.map((r) => <option key={r} value={r}>{t(r) || r}</option>)}
          </select>
          <button data-testid="reg-submit" disabled={loading} className="w-full pp-btn-primary px-4 py-3 rounded-xl">{loading ? "..." : t("register")}</button>
        </form>

        <p className="mt-5 text-sm text-zinc-400">
          {t("already_have_account")} <Link to="/login" data-testid="register-to-login" className="text-[#00E676] hover:underline">{t("login")}</Link>
        </p>
      </div>
    </div>
  );
}
